(function () {
  'use strict';

  const DISCOUNTS = { 1: 0, 2: 20, 3: 25, 4: 30 };

  class BundleBuilder {
    constructor(el) {
      this.el = el;
      this.targetQty = 0;
      this.cart = [];

      this.bindTiers();
      this.bindProducts();
      this.bindCTA();
    }

    bindTiers() {
      this.el.querySelectorAll('.bpn-bundle__tier').forEach(tier => {
        tier.addEventListener('click', () => {
          this.el.querySelectorAll('.bpn-bundle__tier').forEach(t => t.classList.remove('is-active'));
          tier.classList.add('is-active');
          this.targetQty = parseInt(tier.dataset.qty, 10);
          this.cart = [];
          this.el.querySelector('.bpn-bundle__products-section').classList.add('is-visible');
          this.render();
        });
      });
    }

    bindProducts() {
      this.el.querySelectorAll('.bpn-bundle__product').forEach(card => {
        card.addEventListener('click', () => {
          const vid   = card.dataset.variantId;
          const pid   = card.dataset.productId;
          const name  = card.dataset.name;
          const price = parseInt(card.dataset.price, 10);
          const image = card.dataset.image;

          const countInCart = this.cart.filter(i => i.variantId === vid).length;
          const totalInCart = this.cart.length;

          if (countInCart === 0) {
            if (totalInCart < this.targetQty) {
              this.cart.push({ variantId: vid, productId: pid, name, price, image });
            }
          } else {
            if (totalInCart < this.targetQty) {
              this.cart.push({ variantId: vid, productId: pid, name, price, image });
            } else {
              const idx = this.cart.findLastIndex(i => i.variantId === vid);
              if (idx !== -1) this.cart.splice(idx, 1);
            }
          }

          this.render();
        });
      });
    }

    bindCTA() {
      this.el.querySelector('.bpn-bundle__cta').addEventListener('click', () => {
        this.addToCart();
      });
    }

    render() {
      this.renderProgress();
      this.renderSlots();
      this.renderProductStates();
      this.renderSummary();
      this.renderHint();
    }

    renderProgress() {
      const filled = this.cart.length;
      const total  = this.targetQty;
      const pct    = total > 0 ? Math.round((filled / total) * 100) : 0;

      const fill  = this.el.querySelector('.bpn-bundle__progress-fill');
      const label = this.el.querySelector('.bpn-bundle__progress-meta-label');
      const pctEl = this.el.querySelector('.bpn-bundle__progress-meta-pct');

      if (fill)  fill.style.width = pct + '%';
      if (label) label.textContent = `${filled} de ${total} productos`;
      if (pctEl) pctEl.textContent = pct + '%';
    }

    renderSlots() {
      const wrap = this.el.querySelector('.bpn-bundle__slots');
      if (!wrap) return;
      wrap.innerHTML = '';

      for (let i = 0; i < this.targetQty; i++) {
        const item = this.cart[i];
        const slot = document.createElement('div');
        slot.className = 'bpn-bundle__slot' + (item ? ' is-filled' : '');

        if (item && item.image) {
          const img = document.createElement('img');
          img.src = item.image;
          img.alt = item.name;
          slot.appendChild(img);
        } else {
          const ph = document.createElement('div');
          ph.className = 'bpn-bundle__slot-placeholder';
          ph.textContent = '+';
          slot.appendChild(ph);
        }

        wrap.appendChild(slot);
      }
    }

    renderProductStates() {
      const full = this.cart.length >= this.targetQty;

      this.el.querySelectorAll('.bpn-bundle__product').forEach(card => {
        const vid   = card.dataset.variantId;
        const count = this.cart.filter(i => i.variantId === vid).length;
        const isSelected = count > 0;
        const isDisabled = full && count === 0;

        card.classList.toggle('is-selected', isSelected);
        card.classList.toggle('is-disabled', isDisabled);
        card.classList.toggle('has-multi', count > 1);

        const qtyEl = card.querySelector('.bpn-bundle__product-qty');
        if (qtyEl) qtyEl.textContent = count;

        const check = card.querySelector('.bpn-bundle__product-check');
        if (check) {
          check.title = count > 0
            ? (full ? 'Click para quitar uno' : 'Click para agregar otro')
            : '';
        }
      });
    }

    renderSummary() {
      const itemsEl   = this.el.querySelector('.bpn-bundle__summary-items');
      const origEl    = this.el.querySelector('.js-sum-orig');
      const discEl    = this.el.querySelector('.js-sum-disc');
      const discLblEl = this.el.querySelector('.js-sum-disc-label');
      const totalEl   = this.el.querySelector('.js-sum-total');
      const ctaEl     = this.el.querySelector('.bpn-bundle__cta');

      const discPct = DISCOUNTS[this.targetQty] || 0;
      const orig    = this.cart.reduce((s, i) => s + i.price, 0);
      const saving  = Math.round(orig * discPct / 100);
      const total   = orig - saving;

      if (itemsEl) {
        if (!this.cart.length) {
          itemsEl.innerHTML = '<p class="bpn-bundle__summary-empty">Aún no has elegido productos</p>';
        } else {
          const grouped = {};
          this.cart.forEach(i => {
            if (!grouped[i.variantId]) grouped[i.variantId] = { ...i, qty: 0 };
            grouped[i.variantId].qty++;
          });

          itemsEl.innerHTML = Object.values(grouped).map(i => `
            <div class="bpn-bundle__summary-item">
              <img class="bpn-bundle__summary-thumb"
                   src="${i.image || ''}"
                   alt="${i.name}"
                   onerror="this.style.visibility='hidden'">
              <span class="bpn-bundle__summary-name">
                ${i.name}${i.qty > 1 ? ' ×' + i.qty : ''}
              </span>
              <span class="bpn-bundle__summary-price">$${(i.price * i.qty).toLocaleString('es-MX')}</span>
            </div>
          `).join('');
        }
      }

      if (origEl)    origEl.textContent    = '$' + orig.toLocaleString('es-MX');
      if (discEl)    discEl.textContent    = '-$' + saving.toLocaleString('es-MX');
      if (discLblEl) discLblEl.textContent = `Descuento bundle (${discPct}%)`;
      if (totalEl)   totalEl.textContent   = '$' + total.toLocaleString('es-MX');
      if (ctaEl)     ctaEl.disabled        = this.cart.length < this.targetQty;
    }

    renderHint() {
      const hint = this.el.querySelector('.bpn-bundle__hint');
      if (!hint) return;
      const remaining = this.targetQty - this.cart.length;
      if (remaining === 0) {
        hint.textContent = '¡Listo! Tu bundle está completo.';
        hint.classList.add('is-complete');
      } else {
        hint.textContent = `Agrega ${remaining} producto${remaining > 1 ? 's' : ''} más para completar tu bundle`;
        hint.classList.remove('is-complete');
      }
    }

    async addToCart() {
      const cta = this.el.querySelector('.bpn-bundle__cta');
      const originalText = cta.textContent;
      cta.disabled = true;
      cta.textContent = 'Agregando...';

      const discountCodes = { 2: 'BUNDLE2', 3: 'BUNDLE3', 4: 'BUNDLE4' };
      const code = discountCodes[this.targetQty];

      const grouped = {};
      this.cart.forEach(i => {
        grouped[i.variantId] = (grouped[i.variantId] || 0) + 1;
      });

      const items = Object.entries(grouped).map(([id, qty]) => ({
        id: parseInt(id, 10),
        quantity: qty,
        properties: {
          _bundle: 'bpn-bundle',
          _bundle_size: this.targetQty,
          _bundle_discount: DISCOUNTS[this.targetQty] + '%'
        }
      }));

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (!res.ok) throw new Error('Cart error');

        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: code })
        });

        cta.textContent = '¡Listo! Redirigiendo...';
        setTimeout(() => {
          window.location.href = `/checkout?discount=${code}`;
        }, 600);

      } catch (err) {
        console.error('[BPN Bundle]', err);
        cta.disabled = false;
        cta.textContent = 'Error, intenta de nuevo';
        setTimeout(() => { cta.textContent = originalText; }, 2000);
      }
    }
  }

  // ← ESTE ES EL FIX: esperar a que el DOM esté listo
  function init() {
    document.querySelectorAll('[data-bundle-builder]').forEach(el => new BundleBuilder(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();